import AppConstants from 'constants/AppConstants';

/**
 * Opens a section or sections in blueprints
 */
export function openSection(sectionLabels: string | string[]): BaseTockAction<string[]> {
  return {
    type: AppConstants.FLEX_CALENDAR_SECTIONS_OPEN_SECTION,
    payload: typeof sectionLabels === 'string' ? [sectionLabels] : sectionLabels,
  };
}

/**
 * Closes a section or sections in blueprints
 */
export function closeSection(sectionLabels: string | string[]): BaseTockAction<string[]> {
  return {
    type: AppConstants.FLEX_CALENDAR_SECTIONS_CLOSE_SECTION,
    payload: typeof sectionLabels === 'string' ? [sectionLabels] : sectionLabels,
  };
}

/**
 * Toggles the opened state of a section or sections in blueprints
 */
export function toggleSection(sectionLabels: string | string[]): BaseTockAction<string[]> {
  return {
    type: AppConstants.FLEX_CALENDAR_SECTIONS_TOGGLE_SECTION,
    payload: typeof sectionLabels === 'string' ? [sectionLabels] : sectionLabels,
  };
}

/**
 * Closes a section or sections in detailed day calendar.
 */
export function closeUnassignedSection(): BaseTockAction<string[]> {
  return {
    type: AppConstants.FLEX_CALENDAR_UNASSIGNED_SECTION_CLOSE_SECTION,
  };
}

/**
 * Opens a section in detailed day calendar.
 */
export function openUnassignedSection(): BaseTockAction<string[]> {
  return {
    type: AppConstants.FLEX_CALENDAR_UNASSIGNED_SECTION_OPEN_SECTION,
  };
}
